import {
  ebateQueryKeys,
  useEbateQuery,
  getNormalRoles,
  getSubTenantRolesGridData,
  getSubTenantRoleDetails,
  getSubTenantRoleClaims,
} from "queries"
import {
  CacheTime,
  StaleTime,
} from "queries/ebateReactQuery/ebateReactQuery.models"

export const useRoles = (isSubTenantRole: boolean) => {
  const fetch = async () => {
    try {
      const response = await getNormalRoles(isSubTenantRole)
      if (response?.status === 200) {
        return response.data
      }
      return null
    } catch (e) {
      return null
    }
  }

  const roles = useEbateQuery(
    [...ebateQueryKeys.QUERY_KEY_ROLES, isSubTenantRole.toString()],
    fetch,
    {
      cacheTime: CacheTime.medium,
      staleTime: StaleTime.medium,
    }
  )

  return roles
}

export const useSubTenantRolesGridData = (
  isPortal: boolean,
  subtenantCompanyId: number | null | undefined,
  enabled = true
) => {
  const fetch = async () => {
    try {
      const response = await getSubTenantRolesGridData(
        isPortal,
        subtenantCompanyId ?? 0
      )
      if (response?.status === 200) {
        return response.data
      }
      return null
    } catch (e) {
      return null
    }
  }

  const roles = useEbateQuery(
    [
      ...ebateQueryKeys.QUERY_KEY_SUBTENANT_ROLES_GRID_DATA,
      isPortal.toString(),
      (subtenantCompanyId ?? 0).toString(),
    ],
    fetch,
    {
      cacheTime: CacheTime.short,
      staleTime: StaleTime.short,
      enabled,
    }
  )

  return roles
}

export const useSubTenantRoleClaims = () => {
  const fetch = async () => {
    try {
      const response = await getSubTenantRoleClaims()
      if (response?.status === 200) {
        return response.data
      }
      return null
    } catch (e) {
      return null
    }
  }

  const roleClaims = useEbateQuery(
    [...ebateQueryKeys.QUERY_KEY_PORTAL_ROLE_CLAIMS],
    fetch,
    {
      cacheTime: CacheTime.long,
      staleTime: StaleTime.long,
      refetchOnMount: "always",
    }
  )

  return roleClaims
}

export const useSubTenantRoleById = (id: string) => {
  const fetch = async () => {
    try {
      const response = await getSubTenantRoleDetails(id)
      if (response?.status === 200) {
        return response.data
      }
      return null
    } catch (e) {
      return null
    }
  }

  const role = useEbateQuery(
    [...ebateQueryKeys.QUERY_KEY_PORTAL_ROLE_BY_ID, id],
    fetch,
    {
      cacheTime: CacheTime.long,
      staleTime: StaleTime.long,
      refetchOnMount: "always",
    }
  )

  return role
}
